import React from 'react';

import './Badges.scss';

const InfoBadge: React.FunctionComponent<{
    isDiscounted?: boolean;
    isNew?: boolean;
    savingPercent?: number | null;
}> = (props) => {
    // If product has both discount and is new, only the discount badge is shown:
    if (props.isDiscounted && props.savingPercent) {
        return (
            <div className="small-product-teaser__badge small-product-teaser__badge--filled">
                <div>- {props.savingPercent} %</div>
            </div>
        );
    }

    if (props.isNew) {
        return (
            <div className="small-product-teaser__badge">
                <div>Neu</div>
            </div>
        );
    }

    return null;
};

export default InfoBadge;
